import { useState } from "react";
import { Formik, Form } from "formik";
import SidebarField from "../../../components/Sidebar/SidebarField";

import Button from "../../../components/Button";
import DOMPurify from "dompurify";

function AddStockOnHandReport({ currentItems, getAllData, open, handleClose }) {
  const rolesData = []; //useFetchAll(() => AuthApi.getRoles());
  const ComponentTypesData = []; //useFetchAll(() => ComponentTypeApi.getAllComponentTypesData());
  const ComponentData = []; //useFetchAll(() => ComponentApi.getActiveComponents());
  const allPermissions = []; //useFetchAll(() => PermissionApi.getAllPermissionsData());
  const [componentOptions, setComponentOptions] = useState();

  console.log("currentItems", currentItems);

  const initialValues = {
    roleId: currentItems?.roleId?._id || "",
    componentType: currentItems?.componentType?._id || "",
    component: currentItems?.component?._id || "",
    permissions:
      currentItems?.permissions?.map((item) => item.permissionId) || [],
    active: currentItems?.active || false,
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Data", values);

    const permissionPayload = [];
    allPermissions.value?.data?.forEach((item) => {
      if (values?.permissions.includes(item._id)) {
        permissionPayload.push({
          permissionName: item.name,
          permissionId: item._id,
        });
      }
    });

    console.log("permissionPayload", permissionPayload);

    const payload = {
      roleId: values.roleId,
      component: values.component,
      componentType: values.componentType,
      permissions: permissionPayload,
      active: values.active,
    };
  };

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          //   validationSchema={RolePermissionsSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? currentItems?.product?.name
                    : "Add New Role & Permissions"
                }
                button1={
                  <Button text="Close" type="button" onClick={handleClose} />
                }
                // button2={
                //   <Button
                //     text={currentItems?._id ? "Update" : "Submit"}
                //     type="submit"
                //   />
                // }
              >
                <div className="p-4 bg-white shadow-lg rounded-lg">
                  {/* Product Image */}
                  <img
                    src={currentItems?.product?.primary_image}
                    alt={currentItems?.product?.name}
                    className="w-full h-40 object-cover rounded-md"
                  />

                  {/* Transaction Info */}
                  <h2 className="text-lg font-bold mt-4">
                    {currentItems?.product?.name}
                  </h2>
                  {/* <p className="text-gray-600">
                    Vendor: {currentItems?.vendorName}
                  </p> */}
                  {/* <p className="text-gray-600">
                    Transaction Type: {currentItems?.transactionType}
                  </p>
                  <p className="text-gray-600">
                    Date:{" "}
                    {new Date(currentItems?.transactionDate).toDateString()}
                  </p> */}

                  {/* Pricing & Quantity */}
                  <div className="mt-3 p-3 border border-gray-300 rounded-lg bg-gray-100 shadow-sm">
                    <p className="text-gray-800 font-semibold flex justify-between">
                      <span className="text-gray-600">Unit:</span>
                     {currentItems?.unit?.unit}
                    </p>

                    <p className="text-gray-800 font-semibold flex justify-between mt-1">
                      <span className="text-gray-600">Balance Quantity:</span>
                      {currentItems?.balanceQuantity}
                    </p>
                  </div>

                  {/* Description */}
                  <div className="mt-4">
                    <h3 className="text-md font-semibold">Description</h3>
                    <p
                      className="text-gray-600 text-sm mt-2"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          currentItems?.itemDescription
                        ),
                      }}
                    ></p>
                  </div>
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddStockOnHandReport;
